export const backgroundColors = {
  '/': '#fff',
  '/driver': '#7DB6D3',
  '/driver/recover': '#7DB6D3',
  '/driver/signup': '#fff',
  '/driver/dashboard/overview': '#fff',
};

export const phoneRegex = /(09|639)\d{9}$/;
